/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1PecegepayBilletCoursefinpersonpaymentid200,
  PostApiV1PecegepayBilletCoursefinpersonpaymentid400,
  PostApiV1PecegepayBilletCoursefinpersonpaymentid401,
  PostApiV1PecegepayBilletCoursefinpersonpaymentid404,
  PostApiV1PecegepayBilletCoursefinpersonpaymentid500,
  PostApiV1PecegepayBilletCoursefinpersonpaymentidMutationResponse,
  PostApiV1PecegepayBilletCoursefinpersonpaymentidPathParams,
  PostApiV1PecegepayBilletCoursefinpersonpaymentidQueryParams,
} from "../../types/pecegePayBilletController/PostApiV1PecegepayBilletCoursefinpersonpaymentid.ts";
import { bankBilletViewModelSchema } from "../bankBilletViewModelSchema.ts";
import { eFinancialOrderLogTypeSchema } from "../eFinancialOrderLogTypeSchema.ts";

export const postApiV1PecegepayBilletCoursefinpersonpaymentidPathParamsSchema =
  z.object({
    courseFinPersonPaymentId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1PecegepayBilletCoursefinpersonpaymentidPathParams>;

export const postApiV1PecegepayBilletCoursefinpersonpaymentidQueryParamsSchema =
  z.object({
    source: z.optional(
      z
        .lazy(() => eFinancialOrderLogTypeSchema)
        .describe(
          "0 = Undefined | 1 = CreditCardCreationTreasuryStudent | 2 = CreditCardLimitTreasuryStudent | 3 = CreditCardLimitIndividualPaymnent | 4 = CreditCardLimitEnrollment | 5 = BilletEnrollment | 6 = BilletTreasuryStudent | 7 = BilletIndividualPaymnent | 8 = BilletWebhookReturn | 9 = CreditCardWebhookReturn | 10 = CreditCardRecurrence | ",
        ),
    ),
    fineAndInterestOverdueParcelValue: z.coerce.number().default(0),
  }) as unknown as ToZod<PostApiV1PecegepayBilletCoursefinpersonpaymentidQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1PecegepayBilletCoursefinpersonpaymentid200Schema = z.lazy(
  () => bankBilletViewModelSchema,
) as unknown as ToZod<PostApiV1PecegepayBilletCoursefinpersonpaymentid200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1PecegepayBilletCoursefinpersonpaymentid400Schema =
  z.any() as unknown as ToZod<PostApiV1PecegepayBilletCoursefinpersonpaymentid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1PecegepayBilletCoursefinpersonpaymentid401Schema =
  z.any() as unknown as ToZod<PostApiV1PecegepayBilletCoursefinpersonpaymentid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1PecegepayBilletCoursefinpersonpaymentid404Schema =
  z.any() as unknown as ToZod<PostApiV1PecegepayBilletCoursefinpersonpaymentid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1PecegepayBilletCoursefinpersonpaymentid500Schema =
  z.any() as unknown as ToZod<PostApiV1PecegepayBilletCoursefinpersonpaymentid500>;

export const postApiV1PecegepayBilletCoursefinpersonpaymentidMutationResponseSchema =
  z.lazy(
    () => postApiV1PecegepayBilletCoursefinpersonpaymentid200Schema,
  ) as unknown as ToZod<PostApiV1PecegepayBilletCoursefinpersonpaymentidMutationResponse>;
